import { nextActionIdsCompiler } from 'pages/Communications/ScenarioSetupPage/actionCompilers/utils/nextActionIdsCompiler';
import { conditionsCompiler } from 'pages/Communications/ScenarioSetupPage/actionCompilers/utils/conditionsCompiler';
import { StringUse } from 'lib/StringUse';
import { DateUse } from 'lib/DateUse';

export const scheduleTriggerCompiler = (action, filteredArrows) => {
    const {
        id,
        actionType,
        actionParams,
        position,
        settings: {
            atTheDay,
            time,
            condition,
            segmentId,
            values: {
                maxAudienceSize
            }
        }
    } = action;

    const nextActionIdsCompiled = nextActionIdsCompiler(filteredArrows, actionType);

    const conditionsCompiled = conditionsCompiler(condition);

    const utcDateTime = atTheDay.value
        ? DateUse.convertLocalToUTC(`${atTheDay.value} ${time}`, 'DD/MM/YYYY HH:mm', 'YYYY-MM-DD HH:mm')
        : null

    return {
        trigger_id: id,
        trigger_type: 'on_date',
        trigger_params: actionParams,
        coordinates: position,
        trigger_options: {
            datetime: utcDateTime, // '2020-01-01 12:00'
            max_audience_size: StringUse.recast(maxAudienceSize.value, { accepted: 'number', rejected: null }),
            customer_segment: [
                ...conditionsCompiled
            ],
            segment_id: segmentId
        },
        next_actions_ids: [
            ...nextActionIdsCompiled
        ]
    }
}
